import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import PopularComics from './components/PopularComics';
import PlatformStats from './components/PlatformStats';
import CategoryEntries from './components/CategoryEntries';
import UserReviews from './components/UserReviews';
import CTASection from './components/CTASection';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '韩漫网',
      url: 'http://emenculture.com/',
      description: '韩漫网站汇集众多好看的韩国漫画，全部免费观看且提供高清版本',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-6666',
        contactType: 'customer service',
      },
      address: {
        '@type': 'PostalAddress',
        addressLocality: '北京',
        addressRegion: '朝阳区',
        streetAddress: '望京SOHO T1栋A座18层',
      },
    },
    {
      '@type': 'WebSite',
      name: '韩漫网',
      url: 'http://emenculture.com/',
      description: '好看的韩国漫画免费在线阅读平台，提供高清韩漫大全',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'http://emenculture.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '韩漫网 - 首页',
      url: 'http://emenculture.com/',
      isPartOf: { '@id': '#website' },
      about: { '@id': '#organization' },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '韩漫网的漫画都是免费观看的吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '是的，韩漫网所有漫画作品均可免费观看，提供高清画质版本，无需付费即可享受完整阅读体验。',
          },
        },
        {
          '@type': 'Question',
          name: '韩漫网有哪些类型的韩国漫画？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '韩漫网涵盖恋爱、奇幻、动作、悬疑、喜剧、重生、职场等多种类型，满足不同读者的偏好。',
          },
        },
        {
          '@type': 'Question',
          name: '韩漫网的漫画更新频率如何？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '韩漫网每日更新，热门作品基本同步韩国原版更新进度，确保读者第一时间追更。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <PopularComics />
        <PlatformStats />
        <CategoryEntries />
        <UserReviews />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}